const BASE_URL = "https://api.isttekzemin.com"; // Backend API URL

export default BASE_URL;
